import type { BrandCategoryKey } from '../utils/brandCategoryTypes'
import {
  CATEGORY_BRAND_LOGO_FILES,
  brandLogoPublicUrl,
  type CategoryBrandLogoKey,
} from '../utils/brandCategoryLogos'
import NothingDotLogo from './NothingDotLogo'

type Props = {
  brand: BrandCategoryKey
  size?: number
  className?: string
}

const BRAND_FILE_KEY: Partial<Record<BrandCategoryKey, CategoryBrandLogoKey>> = {
  iphone: 'iphone',
  apple: 'apple',
  samsung: 'samsung',
  nokia: 'nokia',
  google: 'google',
  xiaomi: 'xiaomi',
  motorola: 'motorola',
  huawei: 'huawei',
  oneplus: 'oneplus',
  sony: 'sony',
  honor: 'honor',
  asus: 'asus',
  nothing: 'nothing',
  fold: 'fold',
  all: 'all',
}

/** Original manufacturer PNG logos for shop-by-brand tiles. */
export default function BrandCategoryLogo({ brand, size = 64, className = '' }: Props) {
  if (brand === 'nothing') {
    const w = Math.round(size * 1.35)
    return (
      <NothingDotLogo
        width={w}
        className={`vc-brand-logo-svg vc-brand-logo--nothing ${className}`.trim()}
      />
    )
  }

  const fileKey = BRAND_FILE_KEY[brand]
  if (fileKey) {
    const file = CATEGORY_BRAND_LOGO_FILES[fileKey]
    return (
      <img
        src={brandLogoPublicUrl(file)}
        alt=""
        width={size}
        height={size}
        className={`vc-brand-logo-img vc-brand-logo-img--${brand} ${className}`.trim()}
        style={{ objectFit: 'contain', display: 'block' }}
        draggable={false}
      />
    )
  }
  return null
}
